import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import $ from 'jquery';

/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as detailNfaActions from '../../actions/detail_nfa/index';
import * as driverNfaActions from '../../actions/driver_nfa/index';
import * as tasksManagerActions from '../../actions/tasks_manager/index';
import * as accountDriverActions from '../../actions/account_driver/index';

/* Components */
import { Tooltip } from 'react-bootstrap';
import Modal from '../../components/detail_nfa/modal';
import Header from '../../components/detail_nfa/header';
import TitleMain from '../../components/detail_nfa/title';
import Main from '../../components/detail_nfa/main';
import TaskModal from '../../components/tasks_manager/taskModal';

import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index';

class DetailNfa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      modalRight: false,
      showModal: false,
      actualTask: null,
      manageTask: false,
      select: '',
      pag: 1,
      pagModal: 1,
      tags: [],
      filterName: {
        selectTask: null,
        selectDriver: null,
        selectVehicle: null,
        selectState: null
      },
      input: {
        selectTask: '',
        selectDriver: '',
        selectVehicle: '',
        selectState: ''
      },
      arrTags: [],
      sort: {
        ranking: null,
        alias: null,
        averageRisk: null,
        nfa: null
      }
    };
  }

  async componentDidMount() {
    // get the permissions to validate the view
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('nfa');
    if (permit) {
      if (this.props.setting) {
        // get the setting objects
        const obj = JSON.parse(this.props.setting.value);
        const permitsSplited = permits.split(',');
        const manageTasks = permitsSplited.find(function(element) {
          return element == 'task';
        });
        if (manageTasks) {
          this.state.manageTask = true;
        }
        if (obj.generalSetting.views.includes('nfa')) {
          let main;
          if (obj.summaryTruck) {
            main = obj.summaryNFA.main ? obj.summaryNFA.main : obj.generalSetting.main;
          } else {
            main = obj.generalSetting.main;
          }

          const dateStart = this.props.filters.date.fechaStartFinal || null;
          const dateEnd = this.props.filters.date.fechaEndFinal || null;
          const tags = this.props.filters.tags;
          const mainPers = this.props.filters.main || main;

          this.setState({ select: main });
          // call to Form's fetch api
          await this.props.actions.fetchDetailNfaRankingCountApi({ tags, dateStart, dateEnd });
          await this.props.actions.fetchDetailNfaApi({ tags, dateStart, dateEnd });
          await this.props.actions.fetchDetailNfaRankingApi({
            main,
            tags,
            pag: this.state.pag,
            sort: this.state.sort,
            dateStart,
            dateEnd
          });
          await this.props.actions.fetchDetailNfaBPMApi({ tags, dateStart, dateEnd });

          await this.props.actions.fetchDetailNfaModalEvolutionApi({ dateStart, dateEnd, tags });
          await this.props.actions.fetchDetailNfaModalTableApi({
            pag: this.state.pagModal,
            dateStart,
            dateEnd,
            tags,
            filter: this.state.filterName
          });
          await this.props.actions.fetchDetailNfaModalEvolutionFilterApi({
            dateStart,
            dateEnd,
            tags
          });
          await this.props.actions.fetchDetailNfaModalTableCountApi({
            dateStart,
            dateEnd,
            tags,
            filter: this.state.filterName
          });

          // COUNT fetch api call
        } else {
          // not authorized
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      // not authorized
      this.props.history.push('/dashboard/authorization');
    }
  }

  // we load the reset function, return the states to their initial state
  componentWillUnmount() {
    this.props.actions.resetDetailNfa();
  }

  handleModal = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modal ? false : true;
      this.setState({ modal: reset });

      if (!reset) {
        this.setState({ showModal: false });
        this.setState({
          input: {
            selectTask: '',
            selectDriver: '',
            selectVehicle: '',
            selectState: ''
          }
        });
        this.setState({
          filterName: {
            selectTask: null,
            selectDriver: null,
            selectVehicle: null,
            selectState: null
          }
        });
        if (this.props.statusSave == 200) {
        }
      }
    }
  };

  // function performed to sort the table
  handleSort = async event => {
    /* Change sort */
    const sort = { ...this.state.sort };
    if (event.currentTarget.dataset.type === 'ranking') {
      sort.ranking = null;
      sort.alias = null;
      sort.averageRisk = null;
      sort.nfa = null;
    } else if (event.currentTarget.dataset.type === 'alias') {
      sort.ranking = null;
      sort.alias = null;
      sort.averageRisk = null;
      sort.nfa = null;
    } else if (event.currentTarget.dataset.type === 'averageRisk') {
      sort.ranking = null;
      sort.alias = null;
      sort.averageRisk = null;
      sort.nfa = null;
    } else if (event.currentTarget.dataset.type === 'nfa') {
      sort.ranking = null;
      sort.alias = null;
      sort.averageRisk = null;
      sort.nfa = null;
    }

    const value = this.state.sort[event.currentTarget.dataset.type] == 'DESC' ? 'ASC' : 'DESC';
    sort[event.currentTarget.dataset.type] = value;
    /* Get Date */
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate({ id: null }, format);
    /* Set sort */
    this.setState({
      sort
    });
    /* Set Pag */
    this.setState({ pag: 1 });
    /* Fetch */
    await this.props.actions.fetchDetailNfaRankingNoLoadingApi({
      sort,
      pag: 1,
      main: this.state.select,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal
    });
  };

  handleSubmit = async obj => {
    /* Get Date */
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate(obj, format);

    /* Set Pag */
    this.setState({ pag: 1 });
    this.setState({ pagModal: 1 });

    /* TAGS */
    const tags = ObjGeneral.getTags(obj);

    // set filter to persist
    this.props.actions.setFilterDetailNfa({
      date,
      tags
    });

    /* Fetch Ranking Count */
    await this.props.actions.fetchDetailNfaRankingCountApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      tags,
      sort: this.state.sort,
      main: this.state.select
    });

    /* Fetch */
    await this.props.actions.fetchDetailNfaApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      tags,
      pag: 1,
      sort: this.state.sort,
      main: this.state.select
    });

    /* Fetch Ranking */
    await this.props.actions.fetchDetailNfaRankingApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      tags,
      pag: 1,
      sort: this.state.sort,
      main: this.state.select
    });

    /* Fetch BPM */
    await this.props.actions.fetchDetailNfaBPMApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      tags,
      pag: 1,
      sort: this.state.sort,
      main: this.state.select
    });

    await this.props.actions.fetchDetailNfaModalEvolutionApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      tags,
      pag: 1
    });
    await this.props.actions.fetchDetailNfaModalTableApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      tags,
      pag: 1,
      filter: this.state.filterName
    });
    await this.props.actions.fetchDetailNfaModalEvolutionFilterApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      tags,
      pag: 1
    });
    await this.props.actions.fetchDetailNfaModalTableCountApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      tags,
      pag: 1,
      filter: this.state.filterName
    });
  };

  // function performed to paginate
  handleScroll = async event => {
    if (!this.props.modal) {
      if (!this.props.loadingTable) {
        if (this.state.pag < this.props.count.pages) {
          const scroll = event.target.scrollTop;
          const max = event.target.scrollHeight - event.target.offsetHeight;
          if (scroll >= max) {
            /* Change Pag */
            this.setState({
              pag: this.state.pag + 1
            });
            const pag = this.state.pag + 1;
            /* Get Date */
            const objDate = JSON.parse(this.props.setting.value);
            const format = this.props.language.account.date.format;
            const date = ObjGeneral.getDate({ id: null }, format);
            /* Fetch */
            await this.props.actions.fetchDetailNfaRankingNoLoadingApi({
              pag,
              concat: true,
              main: this.state.select,
              dateStart: date.fechaStartFinal,
              dateEnd: date.fechaEndFinal,
              sort: this.state.sort
            });
          }
        }
      }
    }
  };

  // function performed to paginate
  handleScrollModal = async event => {
    if (this.state.pagModal < this.props.datosModalTableCount.pages) {
      const scroll = event.target.scrollTop;
      const max = event.target.scrollHeight - event.target.offsetHeight;
      if (scroll >= max) {
        /* Change Pag */
        this.setState({
          pagModal: this.state.pagModal + 1
        });
        const pag = this.state.pagModal + 1;
        /* Get Date */
        const objDate = JSON.parse(this.props.setting.value);
        const format = this.props.language.account.date.format;
        const date = ObjGeneral.getDate({ id: null }, format);
        /* Fetch */
        await this.props.actions.fetchDetailNfaModalTableNoLoadingApi({
          pag,
          concat: true,
          filter: this.state.filterName
        });
      }
    }
  };

  link = event => {
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate({ id: null }, format);
    const tags = this.props.filters.tags;
    const driver = {
      id: event.currentTarget.dataset.driverid,
      alias: event.currentTarget.dataset.driveralias
    };
    document.getElementById('menu-12-sub-2').classList.remove('active');
    document.getElementById('menu-12-sub-3').classList.add('active');
    this.props.driverActions.setFilterDriverNfa({
      tags: tags,
      date: date,
      driver: driver
    });
    this.props.history.push('/dashboard/driver_nfa');
  };

  handleChange = e => {
    let input = { ...this.state.input };
    input[e.target.dataset.update] = e.target.value;
    this.setState({
      input
    });
  };

  handleFilter = async event => {
    const select = event.target.dataset.select;
    const name = event.target.dataset.name;
    const parent = event.target.dataset.parent;

    document.getElementById(parent).innerHTML = `${
      this.props.language.summary.filter[event.target.dataset.parent]
    }: ${event.target.innerHTML}`;

    const fil = Object.assign({}, this.state.filterName);
    fil[parent] = name;

    this.setState({
      filterName: fil
    });

    /* Get Date */
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate({}, format);

    /* TAGS */
    const tags = ObjGeneral.getTags({});

    /* Set Pag */
    this.setState({ pagModal: 1 });

    /* Fetch */
    await this.props.actions.fetchDetailNfaModalTableNoLoadingApi({
      filter: fil,
      pag: 1,
      tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal
    });

    /* Fetch Count */
    await this.props.actions.fetchDetailNfaModalTableCountApi({
      filter: fil,
      tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal
    });
  };

  handleChangeReset = () => {
    this.setState({
      input: {
        selectTask: '',
        selectDriver: '',
        selectVehicle: '',
        selectState: ''
      }
    });
  };

  handleModalTask = e => {
    var showModal = this.state.showModal ? false : true;
    if (!showModal) {
      this.state.actualTask = null;
    }
    this.setState({ showModal: showModal });
  };

  handleClickTask = async (idTask, index) => {
    this.setState({ showModal: true });
    this.state.actualTask = index;
    this.state.paramTask = null;
    await this.props.taskActions.fetchTaskApi(idTask);
    if (
      this.props.statusTask == 200 &&
      this.props.datosTask.key == 'form_microsleeps' &&
      this.props.datosTask.endTime == null
    ) {
      const obj = JSON.parse(this.props.setting.value);
      await this.props.taskActions.fetchTaskTypesMicrosleepsRecurrenceApi({
        driverId:
          this.props.datosTask.variables && this.props.datosTask.variables.driverId
            ? this.props.datosTask.variables.driverId.value
            : null,
        date:
          this.props.datosTask.variables && this.props.datosTask.variables.start
            ? this.props.datosTask.variables.start.value
            : null,
        deltaTime:
          obj.generalSetting.bpmProcessesSettings &&
          obj.generalSetting.bpmProcessesSettings.microsleepsProcess
            ? obj.generalSetting.bpmProcessesSettings.microsleepsProcess.deltaTime
            : null
      });
    }
  };

  handleCloseTask = async event => {
    event.preventDefault();
    let properties = [];
    let propertiesLookup = {};
    let propsKeys = Object.keys(this.props.datosTask.formProperties);

    for (const entryKey of propsKeys) {
      var propertyValue = this.props.datosTask.formProperties[entryKey];
      if (propertyValue.writable) {
        var input = document.getElementById(propertyValue.id);
        var pair = [];
        var useMultiple = false;
        var multipleValue = '';

        pair.push(propertyValue.id);

        if (input != null) {
          if (input.files) {
            const fullPath = input.files;
            const file = fullPath[0];
            pair.push(file);
            pair.push('file');
          } else {
            pair.push(input.value);
          }
        } else {
          //for multiple values
          input = document.getElementsByName('multiple_' + propertyValue.id);
          if (input.length == 0) {
            console.log('Id no encontrado');
            return null;
          }
          for (var i = 0; i < input.length; i++) {
            if (input[i].checked) {
              multipleValue =
                multipleValue == '' ? input[i].value : multipleValue + ';' + input[i].value;
            }
          }
          pair.push(multipleValue);
          if (multipleValue.indexOf(';') >= 0) {
            useMultiple = true;
          }
        }

        if (pair[1] != '' && pair[1] != null) {
          propertiesLookup[pair[0]] = {
            id: pair[0],
            value: pair[1]
          };

          if (useMultiple) {
            propertiesLookup[pair[0] + '%multiple_enum%'] = {
              id: pair[0] + '%multiple_enum%',
              value: pair[1]
            };
            propertiesLookup[pair[0]].value = pair[1].split(';')[0];
          }

          if (pair.length > 2) {
            propertiesLookup[pair[0]].type = pair[2];
          }
        }
      }
    }
    for (var key in propertiesLookup) {
      properties.push(propertiesLookup[key]);
    }
    await this.props.taskActions.fetchCloseTaskApi(this.props.datosTask, properties);
  };

  handleModalSlide = e => {
    var toHide = $('.slide-panel.show');
    var toShow = $('.slide-panel.hide');

    toHide.addClass('hide');
    toHide.removeClass('show');

    toShow.addClass('show');
    toShow.removeClass('hide');
  };

  handleClickGetTaskFile = async idFile => {
    await this.props.taskActions.fetchTaskFile(idFile);
  };

  render() {
    const obj = JSON.parse(this.props.setting.value);

    const setting = ObjGeneral.getSetting({
      setting: obj.detailNFA,
      filter: this.props.filter,
      general: obj.generalSetting
    });
    // condition done to see if the setting was done
    if (this.props.setting) {
      const header = (
        <Header
          handleSubmit={this.handleSubmit}
          language={this.props.language}
          filter={setting.filter}
          date={this.props.dateMax[5]}
          filters={this.props.filters}
        />
      );
      let container = '';
      // condition performed for loading state of the view
      if (this.props.loading || this.props.loadingBPM || this.props.loadingRanking) {
        container = <Loading language={this.props.language} />;
        // the 401 status of the application Expired token or unauthorized
      } else if (
        this.props.status === 401 ||
        this.props.statusTags === 401 ||
        this.props.statusRanking === 401 ||
        this.props.statusBPM === 401
      ) {
        container = <Expired history={this.props.history} />;
        // the status 200 of the application success
      } else if (
        this.props.status === 200 &&
        this.props.statusTags === 200 &&
        this.props.statusRanking === 200 &&
        this.props.statusBPM === 200
      ) {
        container = (
          <div className="container-detail">
            <TitleMain language={this.props.language} />
            <Modal
              language={this.props.language}
              datosModalEvolution={this.props.datosModalEvolution}
              loadingModalEvolution={this.props.loadingModalEvolution}
              statusModalEvolution={this.props.statusModalEvolution}
              datosModalEvolutionFilter={this.props.datosModalEvolutionFilter}
              loadingModalEvolutionFilter={this.props.loadingModalEvolutionFilter}
              statusModalEvolutionFilter={this.props.statusModalEvolutionFilter}
              datosModalTable={this.props.datosModalTable}
              loadingModalTable={this.props.loadingModalTable}
              statusModalTable={this.props.statusModalTable}
              handleModal={this.handleModal}
              modal={this.state.modal}
              tableNoLoading={this.props.loadingModalTableNoLoading}
              handleScroll={this.handleScrollModal}
              pag={this.state.pagModal}
              count={this.props.datosModalTableCount}
              filter={this.state.filterName}
              handleFilter={this.handleFilter}
              input={this.state.input}
              handleChange={this.handleChange}
              handleChangeReset={this.handleChangeReset}
              handleClickTask={this.handleClickTask}
            />
            <Main
              handleModal={this.handleModal}
              link={this.link}
              filters={this.props.filters}
              handleSort={this.handleSort}
              main={setting.main}
              ranking={this.props.datosRanking}
              date={this.props.dateMax[5]}
              language={this.props.language}
              BPM={this.props.datosBPM}
              datos={this.props.datos}
              title={this.props.language}
              tooltip={this.props.language.detail_fatigue.graphToolTip}
              graphColorRange={obj.graphColorRange.fatigueRiskPercentage}
              nfa={obj.nfa}
              handleScroll={this.handleScroll}
            />

            <TaskModal
              language={this.props.language}
              handleModal={this.handleModalTask}
              showModal={this.state.showModal}
              loading={this.props.loadingTask || this.props.loadingClosingTask}
              taskData={this.props.datosTask}
              handleCloseTask={this.handleCloseTask}
              handleClickGetTaskFile={this.handleClickGetTaskFile}
              statusClosingTask={this.props.statusClosingTask}
              errorClosingTask={this.props.errorClosingTask}
              statusTask={this.props.statusTask}
              errorTask={this.props.errorTask}
              handleModalSlide={this.handleModalSlide}
              extraListData={{
                drivers: this.props.accountDriverDatos,
                microsleepsActionsTexts:
                  obj.generalSetting.bpmProcessesSettings &&
                  obj.generalSetting.bpmProcessesSettings.microsleepsProcess
                    ? obj.generalSetting.bpmProcessesSettings.microsleepsProcess.microsleepsActions
                    : {}
              }}
              tasksTypesData={this.props.tasksTypes}
              tasksTypesHandlers={{
                microsleepsEvents: {
                  microsleepRecurrence: this.handleTaskTypesMicrosleepsRecurrence,
                  microsleepRecurrenceManualChange: this
                    .handleTaskTypesMicrosleepsRecurrenceManualChange
                }
              }}
              manageTask={this.state.manageTask}
            />
            <Tooltip placement="top" id="pageTooltip" />
          </div>
        );
      } else if (
        this.props.status === 500 ||
        this.props.statusTags === 500 ||
        this.props.statusRanking === 500 ||
        this.props.statusBPM === 500
      ) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return (
        <section className="main">
          {header}
          {container}
        </section>
      );
    }

    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}
const mapStateToProps = state => ({
  filter: state.reducer.tags.filter,
  statusTags: state.reducer.tags.status,

  setting: state.reducer.dashboard.setting,
  datos: state.reducer.detailNfa.datos,
  loading: state.reducer.detailNfa.loading,
  status: state.reducer.detailNfa.status,
  datosBPM: state.reducer.detailNfa.datosBPM,
  loadingBPM: state.reducer.detailNfa.loadingBPM,
  statusBPM: state.reducer.detailNfa.statusBPM,
  datosRanking: state.reducer.detailNfa.datosRanking,
  loadingRanking: state.reducer.detailNfa.loadingRanking,
  statusRanking: state.reducer.detailNfa.statusRanking,
  loadingTable: state.reducer.detailNfa.loadingTable,
  loadingModalTableNoLoading: state.reducer.detailNfa.loadingModalTableNoLoading,

  filters: state.reducer.detailNfa.filters,
  count: state.reducer.detailNfa.count,
  statusCount: state.reducer.detailNfa.statusCount,

  datosModalEvolution: state.reducer.detailNfa.datosModalEvolution,
  loadingModalEvolution: state.reducer.detailNfa.loadingModalEvolution,
  statusModalEvolution: state.reducer.detailNfa.statusModalEvolution,

  datosModalTable: state.reducer.detailNfa.datosModalTable,
  loadingModalTable: state.reducer.detailNfa.loadingModalTable,
  statusModalTable: state.reducer.detailNfa.statusModalTable,

  datosModalEvolutionFilter: state.reducer.detailNfa.datosModalEvolutionFilter,
  loadingModalEvolutionFilter: state.reducer.detailNfa.loadingModalEvolutionFilter,
  statusModalEvolutionFilter: state.reducer.detailNfa.statusModalEvolutionFilter,

  datosModalTableCount: state.reducer.detailNfa.datosModalTableCount,
  loadingModalTableCount: state.reducer.detailNfa.loadingModalTableCount,
  statusModalTableCount: state.reducer.detailNfa.statusModalTableCount,

  dateMax: state.reducer.dashboard.dateMax,
  language: state.reducer.dashboard.language,

  datosTask: state.reducer.tasksManager.datosTask,
  loadingTask: state.reducer.tasksManager.loadingTask,
  statusTask: state.reducer.tasksManager.statusTask,
  errorTask: state.reducer.tasksManager.errorTask,
  loadingClosingTask: state.reducer.tasksManager.loadingClosingTask,
  errorClosingTask: state.reducer.tasksManager.errorClosingTask,
  statusClosingTask: state.reducer.tasksManager.statusClosingTask,
  datosClosingTask: state.reducer.tasksManager.datosClosingTask,
  tasksTypes: state.reducer.tasksManager.tasksTypes
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(detailNfaActions, dispatch),
  driverActions: bindActionCreators(driverNfaActions, dispatch),
  taskActions: bindActionCreators(tasksManagerActions, dispatch),
  accountDriverActions: bindActionCreators(accountDriverActions, dispatch)
});
DetailNfa.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailNfa);



// WEBPACK FOOTER //
// ./source/client/containers/detail_nfa/index.jsx